import React from 'react';
import {css, StyleSheet} from "aphrodite/no-important";
import Config from "../config/Config";

const AvastCookieBar = ({onAccept}) => {
    const styles = StyleSheet.create({
        content: {
            display: 'flex',
            maxWidth: 1000,
            flexDirection: 'row',
            justifyContent: 'center',
            verticalAlign: 'middle',
            paddingBottom: 8
        },
        text: {
            flex: 1,
            margin: 'auto',
            padding: '0 50px 0 0',
            verticalAlign: 'middle',
            textAlign: 'left',
            color: '#ADB2B6',
            fontSize: 16,
            fontWeight: 300
        },
        acceptButton: {
            outline: 'none',
            alignSelf: 'center',
            display: 'block',
            height: 50,
            width: 120,
            border: '1px solid white',
            color: 'white',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            transition: 'all .1s ease-in-out',
            ':hover': {
                backgroundColor: 'rgba(0,0,0,0.1)',
            }
        }
    });

    return (
        <div className={css(styles.content)}>
                   <span className={css(styles.text)}
                         dangerouslySetInnerHTML={{__html: Config.messages.cookieMessage.replace("__SET_HREF__", Config.resources.COOKIES_LINK)}}/>
            <button onClick={onAccept}
                    className={css(styles.acceptButton)}>{Config.messages.cookieButton}</button>
        </div>
    );
}

export default AvastCookieBar;
